<template>
  <div
    id="coffeeGenerator"
    class="coffee-generator"
    :class="[{ 'coffee-generator--show': show }]"
  >
    <HolderApp />
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    this.setCircleSize();
    setTimeout(() => {
      this.setCircleSize();
      this.show = true;
    }, 300);
    this.$store.dispatch('getData');
    window.addEventListener('resize', this.setCircleSize);
  },
  destroyed() {
    window.removeEventListener('resize', this.setCircleSize);
  },
  methods: {
    setCircleSize() {
      const w = window.innerWidth;
      this.$store.commit('setWindowWidth', w);
      if (w > 992) {
        this.$store.commit('setCircleSize', 500);
      } else if (w > 460) {
        this.$store.commit('setCircleSize', 400);
      } else {
        this.$store.commit('setCircleSize', (w > 310 ? w : 310) - 60);
      }
    },
  },
};
</script>

<style lang="scss">
.coffee-generator {
  box-sizing: border-box;
  font-family: $textFont;
  user-select: none;
  color: black;
  line-height: initial;
  margin-bottom: 120px;
  opacity: 0;
  transition: opacity 300ms ease-out;

  button {
    font-family: $textFont;
  }

  &, * {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */

    /* Hide scrollbar for IE, Edge and Firefox */
    &::-webkit-scrollbar {
      display: none;
    }
  }
}

.coffee-generator--show {
  opacity: 1;
}

@media (max-width: 780px) {
  .coffee-generator {
    padding-top: 90px;
  }
}
</style>
